// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertyRecommendation__Label {
  color: var(--smartflip-blue);
  font-weight: bold;
  margin-right: 0.2rem;
}
.PropertyRecommendation__Value--Negative {
  color: red;
}`, "",{"version":3,"sources":["webpack://./libs/features/property-recommendation/src/lib/PropertyRecommendation/PropertyRecommendation.component.scss"],"names":[],"mappings":"AACE;EACE,4BAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AAII;EACE,UAAA;AAFN","sourcesContent":[".PropertyRecommendation {\n  &__Label {\n    color: var(--smartflip-blue);\n    font-weight: bold;\n    margin-right: 0.2rem;\n  }\n\n  &__Value {\n    &--Negative {\n      color: red;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
